import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  Select,
  TextField,
  MenuItem,
  Card,
  Divider,
  CardMedia,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
  InputAdornment,
} from '@mui/material';
import { motion } from 'framer-motion';
import { CalendarToday, LocationOn } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScaleIcon from '@mui/icons-material/Scale';
import ToysIcon from '@mui/icons-material/Toys';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Footer from '../components/footer/Footer';
import Header2 from '../components/Header2/Header2';
import Scrollbar from '../components/scrollbar/scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  Autocomplete,
} from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchSingleDumpster } from '../features/dumpsters/dumpsterSlice';
import Loader from './Loader/loader';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import { saveOrder } from '../features/orders/orderSlice';
import DumpsterImage from '../images/dumpster.png';
import { fetchWasteTypes } from '../features/wasteTypes/wasteTypeSlice';

const ProductPage = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyBo2iGar1odYKP2oJfel2UhaLqBTmAiK5s',
    libraries: ['places'],
  });
  const [selectedImage, setSelectedImage] = useState('');
  const DEFAULT_LOCATION = { lat: 37.0552, lng: -95.675 }; // Approx coords of Coffeyville KS
  const DEFAULT_ADDRESS = '2473 Country Rd 3900, Coffeyville, KS 67337, USA';

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug, dumpsterId } = useParams();
  const [activeStep, setActiveStep] = useState(0);

  const { singleCompanyDumpster, loading } = useSelector(
    (state) => state.dumpsters
  );
  console.log('singleCompanyDumpster', singleCompanyDumpster);

  const { wasteTypes, error } = useSelector((state) => state.wasteTypes);

  const [deliveryDate, setDeliveryDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [location, setLocation] = useState(DEFAULT_LOCATION);
  const [deliveryAddress, setDeliveryAddress] = useState({
    address: DEFAULT_ADDRESS,
    coords: { latitude: DEFAULT_LOCATION.lat, longitude: DEFAULT_LOCATION.lng },
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const [notes, setNotes] = useState('');
  const isMobile = useMediaQuery('(max-width:600px)');
  const [locationType, setLocationType] = useState('');
  const [businessName, setBusinessName] = useState('');

  const [selectedWasteTypeId, setSelectedWasteTypeId] = useState('');

  const steps = [
    'Dumpster Detail',
    'Select Dates',
    'Drop-off Location',
    'Review & Confirm',
  ];
  const fadeInVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };
  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place?.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const address = place.formatted_address || place.name;

        setDeliveryAddress({
          address,
          coords: { latitude: lat, longitude: lng },
        });

        setLocation({ lat, lng });
      }
    }
  };

  const fetchAddress = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBo2iGar1odYKP2oJfel2UhaLqBTmAiK5s`
      );
      const data = await response.json();
      console.log('📍 Geocoding raw response:', data);

      if (data.status === 'OK') {
        const countryComponent = data.results
          .flatMap((r) => r.address_components)
          .find((c) => c.types.includes('country'));

        if (countryComponent?.short_name !== 'US') {
          console.warn(
            '🚫 Non-US location selected:',
            countryComponent?.long_name
          );
          return null; // reject non-US results
        }

        // ✅ Return best formatted address (skip plus codes)
        const preferred = data.results.find(
          (r) =>
            !r.types.includes('plus_code') &&
            (r.types.includes('street_address') ||
              r.types.includes('route') ||
              r.types.includes('locality') ||
              r.types.includes('postal_code'))
        );

        return (
          preferred?.formatted_address || data.results[0]?.formatted_address
        );
      }

      return null;
    } catch (error) {
      console.error('🚨 Geocoding API error:', error);
      return null;
    }
  };

  const handleMapClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const address = await fetchAddress(lat, lng);

    if (address) {
      setLocation({ lat, lng });
      setDeliveryAddress({
        address,
        coords: { latitude: lat, longitude: lng },
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Location',
        text: 'Please select a location within the United States.',
      });
    }
  };

  const getUserLocation = () => {
    if (!navigator.geolocation) {
      console.warn('Geolocation not supported, using default Coffeyville KS.');
      setLocation(DEFAULT_LOCATION);
      setDeliveryAddress({
        address: DEFAULT_ADDRESS,
        coords: {
          latitude: DEFAULT_LOCATION.lat,
          longitude: DEFAULT_LOCATION.lng,
        },
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const address = await fetchAddress(latitude, longitude);

        if (address) {
          setLocation({ lat: latitude, lng: longitude });
          setDeliveryAddress({
            address,
            coords: { latitude, longitude },
          });
        } else {
          console.warn('Non-US or invalid, fallback to Coffeyville KS.');
          setLocation(DEFAULT_LOCATION);
          setDeliveryAddress({
            address: DEFAULT_ADDRESS,
            coords: {
              latitude: DEFAULT_LOCATION.lat,
              longitude: DEFAULT_LOCATION.lng,
            },
          });
        }
      },
      (error) => {
        console.error('Error getting location:', error);
        console.warn('Fallback to Coffeyville KS.');
        setLocation(DEFAULT_LOCATION);
        setDeliveryAddress({
          address: DEFAULT_ADDRESS,
          coords: {
            latitude: DEFAULT_LOCATION.lat,
            longitude: DEFAULT_LOCATION.lng,
          },
        });
      }
    );
  };

  useEffect(() => {
    dispatch(fetchSingleDumpster({ slug, dumpsterId }));
  }, [dispatch, slug, dumpsterId]);
  useEffect(() => {
    dispatch(fetchWasteTypes());
  }, [dispatch]);

  useEffect(() => {
    if (singleCompanyDumpster?.data?.image) {
      setSelectedImage(singleCompanyDumpster.data.image);
    }
  }, [singleCompanyDumpster]);
  useEffect(() => {
    getUserLocation();
  }, []);
  const dumpsterSize = singleCompanyDumpster?.data || {};
  console.log('dumpsterSize Promotion', dumpsterSize.promotion);

  if (loading || !isLoaded) {
    return <Loader />;
  }

  const handleFinish = () => {
    const orderData = {
      dumpster_size_id: singleCompanyDumpster?.data?.id,
      waste_type_id: selectedWasteTypeId,
      location_type: locationType,
      from_date: deliveryDate,
      promotion_id: dumpsterSize?.promotion?.id || '',
      to_date: returnDate,
      delivery_address: deliveryAddress,
      is_wallet_used: true,
      note: notes,
      ...(locationType === 'business' && businessName?.trim()
        ? { business_name: businessName.trim() }
        : {}),
    };
    console.log('orderData', orderData);

    Swal.fire({
      title: 'Confirm Order',
      html: `Are you sure you want to proceed to the billing section with the following order details?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, proceed to billing!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saveOrder(orderData));
        navigate('/checkout');
      }
    });
  };
  const handleDeliveryDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = format(newDate, 'yyyy-MM-dd');
      setDeliveryDate(formattedDate);

      const minDays = parseInt(dumpsterSize?.minimum_days) || 1;

      // ✅ Adjust by (minDays - 1) so start date counts as day 1
      const minReturnDate = new Date(newDate);
      minReturnDate.setDate(minReturnDate.getDate() + (minDays - 1));

      const formattedReturnDate = format(minReturnDate, 'yyyy-MM-dd');
      setReturnDate(formattedReturnDate);
    }
  };

  // const handleDeliveryDateChange = (newDate) => {
  //   if (newDate) {
  //     const formattedDate = format(newDate, 'yyyy-MM-dd');
  //     setDeliveryDate(formattedDate);

  //     const minDays = parseInt(dumpsterSize?.minimum_days) || 1;
  //     const minReturnDate = new Date(newDate);
  //     minReturnDate.setDate(minReturnDate.getDate() + minDays);
  //     const formattedReturnDate = format(minReturnDate, 'yyyy-MM-dd');
  //     setReturnDate(formattedReturnDate);
  //   }
  // };

  // const handleDeliveryDateChange = (newDate) => {
  //   if (newDate) {
  //     // Format the new date as 'YYYY-MM-DD'
  //     const formattedDate = format(newDate, 'yyyy-MM-dd');
  //     setDeliveryDate(formattedDate); // Store the formatted date in state

  //     // Do not automatically set the return date when delivery date is changed
  //     // The return date is now optional and only updated when explicitly selected
  //   }
  // };
  const mapStyles = [
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#ffffff' }, { weight: 1.2 }],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#355E3B' }], // dark green land
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#e6f0f5' }], // very light blue/gray water
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }],
    },
  ];

  const handleNext = () => {
    if (activeStep === 1 && !deliveryDate) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Delivery Date',
        text: 'Please select a valid delivery date.',
        confirmButtonColor: '#4CAF50',
      });
      return;
    }
    if (activeStep === 1 && !returnDate) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Return Date',
        text: 'Please select a valid return date.',
        confirmButtonColor: '#4CAF50',
      });
      return;
    }
    if (activeStep === 2) {
      if (!locationType) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Location Type',
          text: 'Please select a location type (Site or Business).',
          confirmButtonColor: '#4CAF50',
        });
        return;
      }
      if (activeStep === 2 && !selectedWasteTypeId) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Waste Type',
          text: 'Please select a waste type.',
          confirmButtonColor: '#4CAF50',
        });
        return;
      }

      if (!location) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Drop-off Location',
          text: 'Please select a drop-off location.',
          confirmButtonColor: '#4CAF50',
        });
        return;
      }

      if (locationType === 'business' && !businessName.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Business Name',
          text: 'Please enter the business name.',
          confirmButtonColor: '#4CAF50',
        });
        return;
      }
    }

    setActiveStep((prevStep) => prevStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  return (
    <>
      <main>
        <Header2 BookDumpster="Book Dumpster" />
        <Box sx={{ mt: 1, padding: 2, mb: 15 }}>
          {/* <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography
              sx={{
                color: '#14331D',
                fontFamily: 'var(--font-body)', // Ensures Plus Jakarta Sans is applied
                fontWeight: '500',
                mb: 4,
              }}
              variant="h5"
              textAlign="center"
            >
              Book Dumpster
            </Typography>
          </motion.div> */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginTop: 0, // Remove top margin
                      paddingTop: 0, // Remove top padding
                    }}
                  >
                    <Stepper
                      activeStep={activeStep}
                      alternativeLabel
                      sx={{
                        width: '100%',
                        background: '#75AD3E',
                        paddingBottom: '10px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: 0,
                        '.MuiStepConnector-root': {
                          display: 'none',
                        },
                      }}
                    >
                      {steps.map((label, index) =>
                        (isMobile && activeStep === index) || !isMobile ? (
                          <Step
                            key={label}
                            sx={{
                              flex: 1,
                              display: 'flex',
                              justifyContent: 'center',
                              margin: 0,
                            }}
                          >
                            <StepLabel
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                fontWeight: 'normal', // Default weight
                                '.MuiStepLabel-label': {
                                  fontWeight:
                                    activeStep === index ? 'bold' : 'normal', // Bold when active
                                  fontSize: '0.875rem',
                                  letterSpacing: 1,
                                  transition: 'all 0.3s ease-in-out',
                                  color:
                                    activeStep === index
                                      ? '#14331D'
                                      : '#14331D59',
                                  whiteSpace: 'nowrap',
                                },
                                '.MuiStepIcon-root': {
                                  display: 'none',
                                },
                              }}
                            >
                              <span
                                style={{
                                  fontSize: '1.0rem',
                                  fontWeight: 'bold',
                                  marginRight: '8px',
                                  color: 'white',
                                  backgroundColor:
                                    activeStep === index
                                      ? '#14331D'
                                      : '#14331D59',
                                  borderRadius: '50%',
                                  padding: '5px 12px',
                                  display: 'inline-block',
                                  textAlign: 'center',
                                }}
                              >
                                {index + 1}
                              </span>
                              {label}
                            </StepLabel>
                          </Step>
                        ) : null
                      )}
                    </Stepper>
                  </Box>

                  <Card
                    sx={{
                      borderRadius: 3,
                      overflow: 'hidden',
                      maxWidth: 1000,
                      mx: 'auto',
                      mt: 2,
                      padding: 3,
                    }}
                  >
                    {activeStep === 0 && (
                      <motion.div
                        variants={fadeInVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                      >
                        <Grid
                          container
                          spacing={4}
                          alignItems="left"
                          justifyContent="left"
                        >
                          <Grid
                            item
                            xs={12}
                            md={6}
                            display="flex"
                            alignItems="left"
                            justifyContent="left"
                            gap={3}
                            flexWrap="wrap"
                          >
                            <CompanyInfoSection
                              imageUrl={selectedImage}
                              companyName={singleCompanyDumpster?.data?.name}
                              price={dumpsterSize.rent}
                              minimumDays={dumpsterSize.minimum_days}
                              promotion={dumpsterSize?.promotion?.discount}
                            />
                          </Grid>
                          <Divider
                            sx={{
                              borderBottom: '2px solid gray',
                              width: '95%',
                              mx: 'auto',
                            }}
                          />
                          <Grid
                            container
                            spacing={3}
                            sx={{
                              textAlign: 'left',
                              justifyContent: 'center',
                              maxWidth: '700px',
                              margin: 'auto',
                              background: '#fff',
                              borderRadius: 2,
                            }}
                          >
                            {[
                              {
                                icon: <StorefrontIcon />,
                                label: 'Dumpster Size ID',
                                value: singleCompanyDumpster?.data?.id || 'N/A',
                              },
                              {
                                icon: <ToysIcon />,
                                label: 'Capacity',
                                value: dumpsterSize?.name || 'N/A',
                              },
                              {
                                icon: <ScaleIcon />,
                                label: 'Weight',
                                value: dumpsterSize?.weight
                                  ? `${dumpsterSize?.weight} Ton`
                                  : 'N/A',
                              },
                              {
                                icon: <ScaleIcon />,
                                label: 'OverDue Charge',
                                value: `${
                                  dumpsterSize?.overdue_charge || 0
                                } lbs`,
                              },
                              {
                                icon: <CalendarMonthIcon />,
                                label: 'Rental Time',
                                value: `${
                                  dumpsterSize?.minimum_days || 0
                                } days`,
                              },
                              {
                                icon: <AttachMoneyIcon />,
                                label: 'Extra Day Charge',
                                value: dumpsterSize?.extra_day_charge
                                  ? `$${dumpsterSize?.extra_day_charge}`
                                  : 'N/A',
                              },
                              // 👇 only push promotion if it exists
                              ...(dumpsterSize?.promotion
                                ? [
                                    {
                                      icon: <AttachMoneyIcon />,
                                      label: 'Promotion Start Date',
                                      value:
                                        dumpsterSize?.promotion?.start_date,
                                    },
                                    {
                                      icon: <AttachMoneyIcon />,
                                      label: 'Promotion End Date',
                                      value: dumpsterSize?.promotion?.end_date,
                                    },
                                  ]
                                : []),
                            ]
                              // filter out null/undefined values
                              .filter(
                                (item) => item?.value && item?.value !== 'N/A'
                              )
                              .map((item, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                  <Box
                                    sx={{
                                      display: 'grid',
                                      gridTemplateColumns: '160px auto',
                                      alignItems: 'center',
                                      py: 1,
                                      borderBottom: '1px solid #ddd',
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 32,
                                          height: 32,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          backgroundColor: '#f0f0f0',
                                          borderRadius: '50%',
                                        }}
                                      >
                                        {item.icon}
                                      </Box>
                                      <Typography
                                        variant="body2"
                                        sx={{ fontFamily: 'var(--font-body)' }}
                                      >
                                        {item.label}
                                      </Typography>
                                    </Box>

                                    <Typography
                                      sx={{
                                        fontSize: '14px',
                                        color: '#555',
                                        textAlign: 'right',
                                      }}
                                    >
                                      {item.value}
                                    </Typography>
                                  </Box>
                                </Grid>
                              ))}
                          </Grid>
                        </Grid>
                      </motion.div>
                    )}

                    {activeStep === 1 && (
                      <motion.div
                        variants={fadeInVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                      >
                        <CompanyInfoSection
                          imageUrl={selectedImage}
                          companyName={singleCompanyDumpster?.data?.name}
                          price={dumpsterSize?.rent}
                          minimumDays={dumpsterSize?.minimum_days}
                          promotion={dumpsterSize?.promotion?.discount}
                        />
                        <Divider
                          sx={{
                            borderBottom: '2px solid gray',
                            width: '95%',
                            mx: 'auto',
                          }}
                        />
                        {dumpsterSize?.promotion && (
                          <>
                            <Box sx={{ mt: 2, mb: 1 }}>
                              <Typography
                                variant="body1"
                                sx={{
                                  mb: 0.5,
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                              >
                                Promotion Start Date
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: '#555', fontSize: '14px' }}
                              >
                                {dumpsterSize?.promotion?.start_date || 'N/A'}
                              </Typography>
                            </Box>

                            <Box sx={{ mt: 1, mb: 2 }}>
                              <Typography
                                variant="body1"
                                sx={{
                                  mb: 0.5,
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                              >
                                Promotion End Date
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: '#555', fontSize: '14px' }}
                              >
                                {dumpsterSize?.promotion?.end_date || 'N/A'}
                              </Typography>
                            </Box>
                          </>
                        )}

                        <Grid item xs={12}>
                          <Box sx={{ mt: 2, mb: 2 }}>
                            <Typography
                              variant="body1"
                              sx={{
                                mb: 1,
                                fontSize: '14px',
                              }}
                            >
                              Delivery Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                value={deliveryDate}
                                onChange={handleDeliveryDateChange}
                                minDate={new Date()}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Choose Delivery Date"
                                    inputProps={{
                                      ...params.inputProps,
                                      placeholder: 'Choose Delivery Date',
                                    }}
                                    sx={{
                                      width: '100%',
                                      height: '40px',
                                      borderRadius: 2,
                                      '& .MuiInputBase-root': {
                                        height: '40px',
                                        border: '1px solid white',
                                        backgroundColor: 'transparent',
                                      },
                                      '& .Mui-focused': {
                                        border: '1px solid white',
                                        backgroundColor: 'transparent',
                                      },
                                      '& input': {
                                        color: 'black',
                                        height: '40px',
                                        fontSize: '14px',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                      },
                                      '& .MuiSvgIcon-root': {
                                        color: 'black',
                                      },
                                      mt: 1,
                                    }}
                                  />
                                )}
                                inputFormat="yyyy-MM-dd"
                              />
                            </LocalizationProvider>
                          </Box>

                          <Box sx={{ mt: 2, mb: 2 }}>
                            <Typography
                              variant="body1"
                              sx={{
                                mb: 1,
                                fontSize: '14px',
                              }}
                            >
                              Return Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                value={returnDate ? new Date(returnDate) : null}
                                onChange={(newDate) => {
                                  if (newDate) {
                                    const formattedDate = format(
                                      newDate,
                                      'yyyy-MM-dd'
                                    );
                                    setReturnDate(formattedDate);
                                  } else {
                                    setReturnDate(null);
                                  }
                                }}
                                minDate={
                                  deliveryDate
                                    ? new Date(
                                        new Date(deliveryDate).setDate(
                                          new Date(deliveryDate).getDate() +
                                            (parseInt(
                                              dumpsterSize?.minimum_days - 1
                                            ) || 1)
                                        )
                                      )
                                    : null
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Choose Return Date"
                                    inputProps={{
                                      ...params.inputProps,
                                      placeholder: 'Choose Return Date',
                                    }}
                                    sx={{
                                      width: '100%',
                                      height: '40px',
                                      borderRadius: 2,
                                      '& .MuiInputBase-root': {
                                        height: '40px',
                                        border: '1px solid white',
                                        backgroundColor: 'transparent',
                                      },
                                      '& .Mui-focused': {
                                        border: '1px solid white',
                                        backgroundColor: 'transparent',
                                      },
                                      '& input': {
                                        color: 'black',
                                        height: '40px',
                                        fontSize: '14px',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                      },
                                      '& .MuiSvgIcon-root': {
                                        color: 'black',
                                      },
                                      mt: 1,
                                    }}
                                  />
                                )}
                                inputFormat="yyyy-MM-dd"
                                disabled={!deliveryDate}
                              />
                            </LocalizationProvider>
                          </Box>
                        </Grid>
                      </motion.div>
                    )}
                    {activeStep === 2 && (
                      <motion.div
                        variants={fadeInVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                      >
                        <CompanyInfoSection
                          imageUrl={selectedImage}
                          companyName={singleCompanyDumpster?.data?.name}
                          price={dumpsterSize.rent}
                          minimumDays={dumpsterSize.minimum_days}
                          promotion={dumpsterSize?.promotion?.discount}
                        />
                        <Divider
                          sx={{
                            borderBottom: '2px solid gray',
                            width: '95%',
                            mx: 'auto',
                          }}
                        />
                        <Grid container spacing={3} mt={2}>
                          <Grid item xs={12}>
                            <div
                              style={{
                                position: 'relative',
                                height: '500px',
                                width: '100%',
                              }}
                            >
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '15%',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  zIndex: 10,
                                  width: '95%',
                                  background: '#f3f4f5',
                                  maxWidth: '100%',
                                  borderRadius: '30px',
                                }}
                              >
                                <Autocomplete
                                  onLoad={setAutocomplete}
                                  onPlaceChanged={handlePlaceChanged}
                                  options={{
                                    componentRestrictions: { country: 'us' },
                                  }}
                                >
                                  <TextField
                                    type="text"
                                    placeholder="Search for a place"
                                    value={deliveryAddress.address || ''}
                                    onChange={(e) =>
                                      setDeliveryAddress({
                                        ...deliveryAddress,
                                        address: e.target.value,
                                      })
                                    }
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '30px',
                                      },
                                    }}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <LocationOnIcon color="action" />
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Autocomplete>
                              </div>
                              <GoogleMap
                                mapContainerStyle={{
                                  height: '100%',
                                  width: '100%',
                                  opacity: 0.7,
                                }}
                                center={location || DEFAULT_LOCATION}
                                zoom={location ? 12 : 4} // zoom out if no location yet
                                onClick={handleMapClick}
                                options={{
                                  styles: mapStyles,
                                  disableDefaultUI: true,
                                }}
                              >
                                {location && (
                                  <Marker
                                    position={location}
                                    draggable={true}
                                    onDragEnd={async (e) => {
                                      const lat = e.latLng.lat();
                                      const lng = e.latLng.lng();

                                      const address = await fetchAddress(
                                        lat,
                                        lng
                                      );

                                      if (address) {
                                        setLocation({ lat, lng });
                                        setDeliveryAddress({
                                          address,
                                          coords: {
                                            latitude: lat,
                                            longitude: lng,
                                          },
                                        });
                                      } else {
                                        Swal.fire({
                                          icon: 'error',
                                          title: 'Invalid Location',
                                          text: 'Please place the marker within the United States.',
                                        });
                                        // snap back marker to last valid US location
                                        setLocation(
                                          deliveryAddress.coords.latitude
                                            ? {
                                                lat: deliveryAddress.coords
                                                  .latitude,
                                                lng: deliveryAddress.coords
                                                  .longitude,
                                              }
                                            : DEFAULT_LOCATION
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </GoogleMap>
                            </div>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sx={{
                              // mt: 3,
                              padding: 2,
                              borderRadius: 2,
                            }}
                          >
                            <Select
                              fullWidth
                              value={locationType}
                              onChange={(e) => setLocationType(e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select Location Type
                              </MenuItem>
                              <MenuItem value="site">Site</MenuItem>
                              <MenuItem value="business">Business</MenuItem>
                            </Select>
                            {locationType === 'business' && (
                              <TextField
                                required
                                fullWidth
                                label="Business Name"
                                value={businessName}
                                onChange={(e) =>
                                  setBusinessName(e.target.value)
                                }
                                variant="outlined"
                                sx={{
                                  mt: 2,
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    backgroundColor: '#fff', // white bg for the input
                                    '& input': {
                                      padding: '12px',
                                    },
                                    '& fieldset': {
                                      borderColor: '#ccc',
                                    },
                                    '&:hover fieldset': {
                                      borderColor: '#888',
                                    },
                                    '&.Mui-focused fieldset': {
                                      borderColor: '#75AD3E', // match your primary theme color
                                    },
                                  },
                                }}
                              />
                            )}
                            <Select
                              fullWidth
                              value={selectedWasteTypeId}
                              onChange={(e) =>
                                setSelectedWasteTypeId(e.target.value)
                              }
                              displayEmpty
                              sx={{ mt: 2 }}
                            >
                              <MenuItem value="" disabled>
                                Select Waste Type
                              </MenuItem>
                              {wasteTypes?.map((type) => (
                                <MenuItem key={type.id} value={type.id}>
                                  {type.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <Typography
                              sx={{
                                fontSize: '16px', // or '0.875rem'
                                color: '#666',
                                marginTop: '15px',
                                marginBottom: '6px',
                                fontWeight: 400, // not bold
                                fontFamily: 'var(--font-body)',
                              }}
                            >
                              Additional notes
                            </Typography>

                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                              placeholder="Input comment"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px',
                                  backgroundColor: '#fff',
                                  '& fieldset': {
                                    borderColor: '#ddd',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: '#bbb',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#75AD3E', // match your theme color if you want
                                  },
                                },
                                '& .MuiInputBase-input': {
                                  fontSize: '14px',
                                  color: '#333',
                                  fontFamily: 'var(--font-body)',
                                },
                                backgroundColor: '#fff',
                              }}
                            />
                          </Grid>
                        </Grid>
                      </motion.div>
                    )}

                    {activeStep === 3 && (
                      <motion.div
                        variants={fadeInVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                      >
                        <CompanyInfoSection
                          imageUrl={selectedImage}
                          companyName={singleCompanyDumpster?.data?.name}
                          price={dumpsterSize.rent}
                          minimumDays={dumpsterSize.minimum_days}
                          locationType={locationType}
                          promotion={dumpsterSize?.promotion?.discount}
                        />
                        <Divider
                          sx={{
                            borderBottom: '2px solid gray',
                            width: '95%',
                            mx: 'auto',
                          }}
                        />
                        <Box
                          sx={{
                            padding: 3,
                            borderRadius: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                borderBottom: '1px solid #eee',
                                pb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: '50%',
                                  backgroundColor: '#f9f9f9', // light grey background
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}
                              >
                                <CalendarMonthIcon sx={{ fontSize: 20 }} />
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'bold', flex: 1 }}
                              >
                                Return Date
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                                {returnDate || 'Not selected'}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                borderBottom: '1px solid #eee',
                                pb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: '50%',
                                  backgroundColor: '#f9f9f9', // light grey background
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}
                              >
                                <CalendarMonthIcon sx={{ fontSize: 20 }} />
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'bold', flex: 1 }}
                              >
                                Delivery Date
                              </Typography>
                              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                                {deliveryDate || 'Not selected'}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 1,
                                borderBottom: '1px solid #eee',
                                pb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: '50%',
                                  backgroundColor: '#f9f9f9', // light grey background
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}
                              >
                                <LocationOn sx={{ fontSize: 22 }} />
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'bold', flex: 1 }}
                              >
                                Location Type
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  opacity: 0.8,
                                  textAlign: 'right',
                                  maxWidth: '60%',
                                }}
                              >
                                {locationType || 'Not provided'}
                              </Typography>
                            </Box>
                            {selectedWasteTypeId && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: 1,
                                  borderBottom: '1px solid #eee',
                                  pb: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: '50%',
                                    backgroundColor: '#f9f9f9',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                  }}
                                >
                                  <ToysIcon sx={{ fontSize: 22 }} />
                                </Box>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 'bold', flex: 1 }}
                                >
                                  Waste Type
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    opacity: 0.8,
                                    textAlign: 'right',
                                    maxWidth: '60%',
                                  }}
                                >
                                  {wasteTypes.find(
                                    (type) => type.id === selectedWasteTypeId
                                  )?.name || 'N/A'}
                                </Typography>
                              </Box>
                            )}

                            {locationType === 'business' && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  gap: 1,
                                  borderBottom: '1px solid #eee',
                                  pb: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: '50%',
                                    backgroundColor: '#f9f9f9', // light grey background
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                  }}
                                >
                                  <BusinessIcon sx={{ fontSize: 22 }} />
                                </Box>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 'bold', flex: 1 }}
                                >
                                  Business Name
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    opacity: 0.8,
                                    textAlign: 'right',
                                    maxWidth: '60%',
                                  }}
                                >
                                  {businessName || 'Not provided'}
                                </Typography>
                              </Box>
                            )}

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 1,
                                borderBottom: '1px solid #eee',
                                pb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: '50%',
                                  backgroundColor: '#f9f9f9', // light grey background
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}
                              >
                                <LocationOn
                                  sx={{ fontSize: 22, color: '#14331D' }}
                                />
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 'bold', flex: 1 }}
                              >
                                Delivery address
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  opacity: 0.8,
                                  textAlign: 'right',
                                  maxWidth: '60%',
                                }}
                              >
                                {deliveryAddress?.address || 'Not provided'}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </motion.div>
                    )}
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      {activeStep === 0 ? (
                        // Only show "Next" aligned to right
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                          }}
                        >
                          <Button
                            onClick={handleNext}
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1rem',
                              letterSpacing: 1,
                              padding: '8px 16px',
                              borderRadius: 2,
                              textAlign: 'center',
                              transition: 'all 0.3s ease-in-out',
                              background: '#14331D',
                              color: '#fff',
                              width: { xs: '100%', sm: 'auto' },
                              '&:hover': {
                                background: '#75AD3E',
                              },
                            }}
                          >
                            Next
                          </Button>
                        </Box>
                      ) : (
                        // From step 1 onwards, show both Back & Next spaced apart
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: { xs: 'column-reverse', sm: 'row' },
                            width: '100%',
                            gap: 2,
                          }}
                        >
                          <Button
                            onClick={handleBack}
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1rem',
                              letterSpacing: 1,
                              padding: '8px 16px',
                              borderRadius: 2,
                              textAlign: 'center',
                              transition: 'all 0.3s ease-in-out',
                              background: '#75AD3E',
                              color: 'white',
                              border: '1px solid #B0B0B0',
                              width: { xs: '100%', sm: 'auto' },
                              '&:hover': {
                                background: '#f0f0f0',
                              },
                            }}
                          >
                            Back
                          </Button>
                          <Button
                            onClick={
                              activeStep === steps.length - 1
                                ? handleFinish
                                : handleNext
                            }
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '1rem',
                              letterSpacing: 1,
                              padding: '8px 16px',
                              borderRadius: 2,
                              textAlign: 'center',
                              transition: 'all 0.3s ease-in-out',
                              background: '#14331D',
                              color: '#fff',
                              width: { xs: '100%', sm: 'auto' },
                              '&:hover': {
                                background: '#75AD3E',
                              },
                            }}
                          >
                            {activeStep === steps.length - 1
                              ? 'Finish'
                              : 'Next'}
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Card>
                </motion.div>
              </Grid>
            </Grid>
          </motion.div>
        </Box>
      </main>
      <Scrollbar />
      <Footer />
    </>
  );
};

const CompanyInfoSection = ({
  imageUrl,
  companyName,
  price,
  minimumDays,
  promotion,
  locationType,
}) => {
  console.log('promotions', promotion);
  console.log('companyName', companyName);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px 15px',
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          mr: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          borderRadius: '50%',
          border: '1px solid #ddd',
        }}
      >
        <ImageSection imageUrl={imageUrl} />
      </Box>

      <Box>
        <Typography
          variant="h5"
          sx={{
            color: 'gray',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {companyName}
        </Typography>

        <PricingSection
          price={price}
          minimumDays={minimumDays}
          promotion={promotion}
        />
      </Box>
    </Box>
  );
};

const PricingSection = ({ price, minimumDays, promotion }) => {
  // calculate discounted price if promotion exists
  const discountedPrice = promotion
    ? (price - (price * promotion) / 100).toFixed(2)
    : null;

  return (
    <Box
      sx={{
        background: '#75AD3E',
        mt: 1,
        borderRadius: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 1, sm: 1, md: 1 },
        transition: '0.3s ease-in-out',
        maxWidth: '400px',
        width: '100%',
        '&:hover': {
          scale: '1.05',
        },
        '@media (max-width: 600px)': {
          flexDirection: 'column',
          textAlign: 'center',
        },
      }}
    >
      {promotion ? (
        <Box>
          <Typography
            variant="h6"
            sx={{ color: '#fff', textDecoration: 'line-through', opacity: 0.7 }}
          >
            ${price} / {minimumDays ? `${minimumDays} Days` : 'Days'}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.3rem' },
              color: '#fff',
              fontWeight: 'bold',
            }}
          >
            ${discountedPrice} / {minimumDays ? `${minimumDays} Days` : 'Days'}{' '}
            🎉
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: '#ffeb3b', fontWeight: 'bold' }}
          >
            {promotion}% OFF
          </Typography>
        </Box>
      ) : (
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.3rem' },
            color: '#fff',
          }}
        >
          ${price} / {minimumDays ? `${minimumDays} Days` : 'Days'}
        </Typography>
      )}
    </Box>
  );
};

const ImageSection = ({ imageUrl }) => (
  <motion.div
    key={imageUrl}
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.4 }}
    style={{
      width: '100%',
      height: '100%',
    }}
  >
    <img
      src={imageUrl || DumpsterImage}
      alt=""
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      }}
    />
  </motion.div>
);

export default ProductPage;
